export default {
    jsonUrl: '/wp-content/plugins/eon-vue-filter/store/glasses.json?v=1',
    glassesBaseUrl: '/wp-content/uploads/glasses/',
    themesMediaBaseUrl: '/wp-content/themes/eyewear/images/',
}